import TeamIcon from "@mui/icons-material/People";
import type { ClassNameMap } from "@mui/material";
import clsx from "clsx";

import type { Team } from "@citrine/resources/team";

import * as sx from "./index.sx";

type TeamInfoClassKey = "container" | "icon" | "name";

export function TeamInfo({
  className,
  team,
  classes,
}: {
  className?: string;
  team?: Team;
  classes?: Partial<ClassNameMap<TeamInfoClassKey>>;
}) {
  return team ? (
    <sx.Container
      className={clsx(classes?.container, className)}
      title={team.name}
    >
      <TeamIcon className={classes?.icon} />
      <sx.TeamName className={classes?.name} tooltip={false}>
        {team.name}
      </sx.TeamName>
    </sx.Container>
  ) : null;
}
